export const CM_SESSION_IDLE_TIMEOUT = 1000 * 60 * 10; // 10 minutes
